import { theme } from '@/theme';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

export const Path = styled.path`
  transition: fill 0.3s;
`;

type Type = 'horizontal' | 'vertical' | 'triangle' | 'plain';

type LogoProps = {
  type: Type;
  width?: string;
  height?: string;
  color?: string;
  className?: string;
  onClick?: () => void;
};

export const Logo: FunctionComponent<LogoProps> = ({
  type,
  width = '100%',
  height = '100%',
  color = theme.colors.black,
  className,
  onClick
}) => (
  <svg
    onClick={onClick}
    width={width}
    height={height}
    viewBox={viewBox[type]}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={className}
  >
    {getPath(type, color)}
  </svg>
);

const viewBox: Record<Type, string> = {
  horizontal: '0 0 152 36',
  vertical: '0 0 236.2 205.2',
  triangle: '0 0 115.3 98.8',
  plain: '0 0 180 54'
};

const getPath = (type: Type, color: string) => {
  switch (type) {
    case 'horizontal':
      return (
        <>
          <path
            d="M41.3822 30.4686L38.187 35.8459L3.11719 35.9239L17.5348 10.9854L20.6466 16.3721L15.7314 25.0094L12.625 30.4686H41.3822Z"
            fill="#E9E9E9"
          />
          <path
            d="M17.5341 10.9863L20.6459 16.373L16.7333 23.1678L12.168 20.2604L17.5341 10.9863Z"
            fill="url(#paint0_linear_2776_1821)"
          />
          <path
            d="M20.6467 16.3725L17.5349 10.9858L3.11731 35.9243L0 30.469L17.5349 0.0751953L31.8745 25.0137H25.6399L20.6467 16.3725Z"
            fill="#0072FF"
          />
          <path
            d="M31.8543 24.9996L25.6302 25.0068L21.7061 18.2139L26.5114 15.7057L31.8543 24.9996Z"
            fill="url(#paint1_linear_2776_1821)"
          />
          <path
            d="M23.8473 0.0751953L41.3822 30.469H12.625L15.7314 25.0098L15.7384 25.0137H25.6398H31.8744L17.5348 0.0751953H23.8473Z"
            fill="#FF4658"
          />
          <path
            d="M12.625 30.4694L15.7289 25.0143L23.7202 24.995L23.4706 30.4503L12.625 30.4694Z"
            fill="url(#paint2_linear_2776_1821)"
          />
          <rect x="52.3828" y="3.73535" width="0.683334" height="28.5292" fill="#E9E9E9" />
          <path
            d="M76.1291 7.4731V4.8252H68.9046V7.4731H76.1291ZM71.5525 26.695C73.7427 26.695 75.6714 25.845 76.9464 24.3413V26.368H80.575V10.1864H76.9464V12.2459C75.6714 10.7421 73.7427 9.85949 71.5525 9.85949C67.1066 9.85949 64.0664 13.6189 64.0664 18.2936C64.0664 22.9356 67.1066 26.695 71.5525 26.695ZM72.4678 23.1971C69.7218 23.1971 67.7604 21.1376 67.7604 18.2936C67.7604 15.4495 69.7218 13.3573 72.4678 13.3573C75.0503 13.3573 76.9464 15.4495 76.9464 18.2936C76.9464 21.1703 75.0176 23.1971 72.4678 23.1971ZM91.6243 31.1735C96.2663 31.1735 100.058 28.3295 100.058 22.6741V10.1864H96.5932V12.6055C95.7432 11.0036 93.553 9.85949 91.1012 9.85949C86.6227 9.85949 83.6805 13.3573 83.6805 17.7051C83.6805 22.0529 86.6227 25.5181 91.1012 25.5181C94.0433 25.5181 95.7759 24.047 96.4297 22.7394V22.8702C96.4297 26.1719 94.7298 28.3948 91.2647 28.3948C89.5975 28.3948 87.7014 27.8391 86.4265 26.7276L85.0208 29.016C86.5246 30.3563 88.8456 31.1735 91.6243 31.1735ZM91.8858 22.3472C89.3359 22.3472 87.3745 20.3857 87.3745 17.7051C87.3745 15.0245 89.3359 13.0304 91.8858 13.0304C94.4356 13.0304 96.4297 14.9919 96.4297 17.5744C96.4297 20.3857 94.501 22.3472 91.8858 22.3472ZM111.761 26.695C116.534 26.695 120.359 22.9683 120.359 18.2936C120.359 13.5862 116.534 9.85949 111.761 9.85949C106.989 9.85949 103.164 13.5862 103.164 18.2936C103.164 22.9683 106.989 26.695 111.761 26.695ZM111.761 23.1971C108.983 23.1971 106.858 21.1049 106.858 18.2936C106.858 15.4495 108.983 13.3573 111.761 13.3573C114.54 13.3573 116.665 15.4495 116.665 18.2936C116.665 21.1049 114.54 23.1971 111.761 23.1971ZM127.093 26.368V19.7646C127.093 15.5149 129.381 13.815 132.945 13.815V9.85949C129.48 9.85949 127.714 11.7555 127.093 13.39V10.1864H123.465V26.368H127.093ZM142.458 26.695C144.648 26.695 146.577 25.845 147.851 24.3413V26.368H151.48V10.1864H147.851V12.2459C146.577 10.7421 144.648 9.85949 142.458 9.85949C138.012 9.85949 134.971 13.6189 134.971 18.2936C134.971 22.9356 138.012 26.695 142.458 26.695ZM143.373 23.1971C140.627 23.1971 138.665 21.1376 138.665 18.2936C138.665 15.4495 140.627 13.3573 143.373 13.3573C145.955 13.3573 147.851 15.4495 147.851 18.2936C147.851 21.1703 145.923 23.1971 143.373 23.1971Z"
            fill="#212121"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2776_1821"
              x1="18.8446"
              y1="15.9833"
              x2="12.5243"
              y2="18.618"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0.3" />
              <stop offset="0.252573" stopOpacity="0.137748" />
              <stop offset="0.490551" stopOpacity="0.01" />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_2776_1821"
              x1="26.8652"
              y1="23.6471"
              x2="27.7524"
              y2="16.8274"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0.3" />
              <stop offset="0.252573" stopOpacity="0.137748" />
              <stop offset="0.490551" stopOpacity="0.01" />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_2776_1821"
              x1="16.3401"
              y1="26.7754"
              x2="21.8393"
              y2="30.9703"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0.3" />
              <stop offset="0.252573" stopOpacity="0.137748" />
              <stop offset="0.490551" stopOpacity="0.01" />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
          </defs>
        </>
      );
    case 'vertical':
      return (
        <>
          <polygon
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_36_"
            fill="#2459F5"
            points="111.9,0 151.6,68.9 134.3,68.9 111.9,30.6 71.8,98.8 62.9,83.2 "
          />
          <polygon
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_35_"
            fill="#E04E50"
            points="178.1,83.7 98.6,84.3 107.5,68.9 151.6,68.9 111.9,0 130,0 "
          />
          <polygon
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_33_"
            fill="#E7E3E8"
            points="71.8,98.8 111.9,30.6 120.8,45.9 98.6,84.3 178.1,83.7 171.7,98.8 "
          />
          <g xmlns="http://www.w3.org/2000/svg" id="XMLID_2_">
            <path
              id="XMLID_17_"
              d="M0,168.5c0-6.8,1.9-12.5,5.8-17.1c3.9-4.6,8.8-6.9,14.8-6.9c6,0,10.7,2.7,14.2,8.2v-7.3h9.8v46.1h-9.8v-7.2   c-3.5,5.4-8.2,8.1-14.2,8.1c-6,0-11-2.3-14.8-6.9C1.9,180.9,0,175.2,0,168.5z M13.6,158.5c-2.4,2.7-3.6,6-3.6,10.1   c0,4,1.2,7.4,3.6,10c2.4,2.6,5.4,4,9.2,4c3.5,0,6.4-1.3,8.7-3.9c2.3-2.6,3.4-6,3.4-10.1c0-4-1.1-7.4-3.4-10.1c-2.3-2.7-5.2-4-8.7-4   C19,154.5,16,155.8,13.6,158.5z"
            />
            <path
              id="XMLID_20_"
              d="M53.4,166.4c0-6.2,1.9-11.4,5.8-15.6c3.9-4.2,8.8-6.3,14.8-6.3c2.8,0,5.4,0.7,7.8,2c2.4,1.3,4.4,3.1,6,5.4   v-6.4h9.8v35.7c0,4.1-0.7,7.7-2.1,10.9c-1.4,3.2-3.3,5.7-5.5,7.5c-2.3,1.8-4.7,3.2-7.3,4.1c-2.6,0.9-5.2,1.4-7.9,1.4   c-7.3,0-13.3-2.1-17.9-6.3l4.3-6.9c3.5,3.4,7.9,5,13.1,5c0.9,0,1.8-0.1,2.9-0.3c1-0.2,2.2-0.7,3.5-1.3c1.3-0.7,2.4-1.5,3.4-2.4   c1-1,1.9-2.3,2.6-3.9c0.7-1.6,1.1-3.5,1.1-5.5v-1.9c-3.2,4.8-7.8,7.3-13.8,7.3c-6,0-11-2.2-14.8-6.5   C55.3,178.1,53.4,172.8,53.4,166.4z M63.4,166.7c0,3.8,1.1,6.8,3.3,9.2s5.1,3.5,8.5,3.5c3.5,0,6.3-1.2,8.5-3.5   c2.2-2.3,3.3-5.4,3.3-9.2c0-3.7-1.1-6.7-3.3-9.1c-2.2-2.4-5-3.6-8.4-3.6c-3.4,0-6.2,1.2-8.5,3.6C64.5,160.1,63.4,163.1,63.4,166.7z   "
            />
            <path
              id="XMLID_25_"
              d="M106.4,168.5c0-6.6,2.3-12.3,6.8-17c4.5-4.7,10-7,16.4-7c6.4,0,11.9,2.3,16.4,7c4.5,4.7,6.8,10.3,6.8,17   c0,6.6-2.3,12.2-6.8,16.9c-4.5,4.7-10,7-16.4,7c-6.4,0-11.9-2.3-16.4-7C108.7,180.7,106.4,175.1,106.4,168.5z M116.4,168.5   c0,3.9,1.3,7.2,3.9,9.9c2.6,2.7,5.7,4,9.4,4c3.7,0,6.8-1.3,9.4-4c2.6-2.7,3.9-6,3.9-9.9c0-3.8-1.3-7.2-3.9-9.9   c-2.6-2.8-5.7-4.1-9.4-4.1c-3.7,0-6.8,1.4-9.4,4.1C117.7,161.4,116.4,164.7,116.4,168.5z"
            />
            <path
              id="XMLID_40_"
              d="M161.7,191.5v-46.1h9.8v9.1c1-2.7,2.8-5.1,5.4-7.1c2.6-2,6.1-3,10.4-3v11.3c-10.6,0-15.8,5.6-15.8,16.9   v18.8H161.7z"
            />
            <path
              id="XMLID_42_"
              d="M191.6,168.5c0-6.8,1.9-12.5,5.8-17.1c3.9-4.6,8.8-6.9,14.8-6.9c6,0,10.7,2.7,14.2,8.2v-7.3h9.8v46.1h-9.8   v-7.2c-3.5,5.4-8.2,8.1-14.2,8.1c-6,0-11-2.3-14.8-6.9C193.5,180.9,191.6,175.2,191.6,168.5z M205.1,158.5c-2.4,2.7-3.6,6-3.6,10.1   c0,4,1.2,7.4,3.6,10c2.4,2.6,5.4,4,9.2,4c3.5,0,6.4-1.3,8.7-3.9c2.3-2.6,3.4-6,3.4-10.1c0-4-1.1-7.4-3.4-10.1c-2.3-2.7-5.2-4-8.7-4   C210.6,154.5,207.5,155.8,205.1,158.5z"
            />
          </g>
          <rect
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_31_"
            x="12"
            y="129.8"
            width="20.5"
            height="8.5"
          />
          <linearGradient
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_127_"
            gradientUnits="userSpaceOnUse"
            x1="122.5452"
            y1="44.9659"
            x2="118.3786"
            y2="47.9659"
          >
            <stop offset="0" style={{ stopColor: '#001E2A' }} />
            <stop offset="1" style={{ stopColor: '#E7E3E8', stopOpacity: 0 }} />
          </linearGradient>
          <polyline
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_50_"
            fill="url(#XMLID_127_)"
            points="71.8,98.8 111.9,30.6 120.8,45.9 98.6,84.3 "
          />
          <linearGradient
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_128_"
            gradientUnits="userSpaceOnUse"
            x1="105.2901"
            y1="70.4664"
            x2="114.4151"
            y2="73.2164"
          >
            <stop offset="0" style={{ stopColor: '#B54E50' }} />
            <stop offset="1" style={{ stopColor: '#E04E50', stopOpacity: 0 }} />
          </linearGradient>
          <polyline
            xmlns="http://www.w3.org/2000/svg"
            id="XMLID_49_"
            fill="url(#XMLID_128_)"
            points="178.1,83.7 98.6,84.3 107.5,68.9 151.5,68.6 "
          />
        </>
      );
    case 'triangle':
      return (
        <>
          <polygon id="XMLID_129_" fill="#2459F5" points="49,0 88.7,68.9 71.5,68.9 49,30.6 9,98.8 0,83.2 " />
          <polygon
            id="XMLID_128_"
            fill="#E04E50"
            points="115.3,83.7 35.7,84.3 44.6,68.9 88.7,68.9 49,0 67.1,0 "
          />
          <polygon
            id="XMLID_127_"
            fill="#E7E3E8"
            points="9,98.8 49,30.6 58,45.9 35.7,84.3 115.3,83.7 108.8,98.8 "
          />
          <linearGradient
            id="XMLID_68_"
            gradientUnits="userSpaceOnUse"
            x1="62.1123"
            y1="113.9355"
            x2="62.1123"
            y2="90.9331"
          >
            <stop offset="0" style={{ stopColor: '#00002A', stopOpacity: 0.5 }} />
            <stop offset="0.5148" style={{ stopColor: '#79778D', stopOpacity: 0.2426 }} />
            <stop offset="1" style={{ stopColor: '#E7E3E8', stopOpacity: 0 }} />
          </linearGradient>
          <polygon
            id="XMLID_35_"
            fill="url(#XMLID_68_)"
            points="9,98.8 49,30.6 58,45.9 35.9,84.3 115.3,83.7 108.8,98.8 "
          />
          <linearGradient
            id="XMLID_69_"
            gradientUnits="userSpaceOnUse"
            x1="59.2933"
            y1="47.653"
            x2="55.058"
            y2="50.0982"
          >
            <stop offset="0" style={{ stopColor: '#001E2A', stopOpacity: 0.5 }} />
            <stop offset="1" style={{ stopColor: '#E7E3E8', stopOpacity: 0 }} />
          </linearGradient>
          <polygon id="XMLID_95_" fill="url(#XMLID_69_)" points="9,98.8 49,30.6 58,45.9 35.7,84.3 " />
          <linearGradient
            id="XMLID_70_"
            gradientUnits="userSpaceOnUse"
            x1="47.6636"
            y1="67.9163"
            x2="55.1174"
            y2="72.2198"
          >
            <stop offset="0" style={{ stopColor: '#B54E50', stopOpacity: 0.7 }} />
            <stop offset="1" style={{ stopColor: '#E04E50', stopOpacity: 0 }} />
          </linearGradient>
          <polygon id="XMLID_94_" fill="url(#XMLID_70_)" points="115.3,83.7 35.7,84.3 44.6,68.9 88.7,68.9 " />
        </>
      );
    case 'plain':
      return (
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M24.84 5.427V0H9.962v5.427h14.876zM15.414 44.82c4.51 0 8.482-1.742 11.107-4.823v4.153h7.472V10.988h-7.472v4.22c-2.625-3.081-6.597-4.89-11.107-4.89C6.26 10.318 0 18.022 0 27.603c0 9.514 6.26 17.218 15.415 17.218zm1.885-7.168c-5.655 0-9.693-4.221-9.693-10.05 0-5.829 4.038-10.117 9.693-10.117 5.318 0 9.222 4.288 9.222 10.117 0 5.896-3.971 10.05-9.222 10.05zM56.747 54c9.558 0 17.367-5.829 17.367-17.42V10.989h-7.136v4.957c-1.75-3.283-6.26-5.627-11.309-5.627-9.222 0-15.28 7.168-15.28 16.079 0 8.91 6.058 16.012 15.28 16.012 6.059 0 9.626-3.014 10.973-5.694v.268c0 6.766-3.5 11.322-10.636 11.322-3.433 0-7.337-1.139-9.963-3.417l-2.894 4.69C46.245 52.325 51.025 54 56.746 54zm.538-18.09c-5.25 0-9.29-4.02-9.29-9.513 0-5.494 4.04-9.58 9.29-9.58 5.25 0 9.357 4.02 9.357 9.312 0 5.762-3.972 9.782-9.357 9.782zm40.927 8.911c9.828 0 17.704-7.637 17.704-17.218 0-9.648-7.876-17.285-17.704-17.285S80.51 17.955 80.51 27.603c0 9.58 7.876 17.218 17.703 17.218zm0-7.168c-5.721 0-10.097-4.288-10.097-10.05 0-5.829 4.376-10.117 10.097-10.117 5.722 0 10.098 4.288 10.098 10.117 0 5.762-4.376 10.05-10.098 10.05zm31.571 6.498V30.618c0-8.71 4.712-12.194 12.049-12.194v-8.106c-7.135 0-10.77 3.886-12.049 7.235v-6.565h-7.472V44.15h7.472zm31.638.67c4.51 0 8.482-1.742 11.107-4.823v4.153H180V10.988h-7.472v4.22c-2.625-3.081-6.597-4.89-11.107-4.89-9.155 0-15.415 7.704-15.415 17.285 0 9.514 6.26 17.218 15.415 17.218zm1.885-7.168c-5.655 0-9.693-4.221-9.693-10.05 0-5.829 4.038-10.117 9.693-10.117 5.318 0 9.222 4.288 9.222 10.117 0 5.896-3.972 10.05-9.222 10.05z"
          fill={color}
        />
      );
  }
};
